import React, { useState } from "react";
import { Form, Input, Select, Row, Col } from "antd";
import { Button } from "react-bootstrap";
import ImageUploader from "./ImageUploader";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { StyledForm, ImgaeSection, Header } from "../Style/styles";
import PhoneAuth from "../Firebase-Auth/PhoneAuth";
import sendNotificationCall from "../API-Call/sendNotificationCall";

const { Option } = Select;

const SendNotification = ({ setShowPromCode }) => {
  const MySwal = withReactContent(Swal);
  const [form] = Form.useForm();
  const [countryTrue, setCountryTrue] = useState(false);
  const [isCorrectCode, setIsCorrectCode] = useState(
    localStorage.getItem("isLoggedIn") === "true",
  );
  const [imageTrue, setImageTrue] = useState(false);
  const [image_En_Data, setImage_En_data] = useState("");
  const [image_Ar_Data, setImage_Ar_data] = useState("");
  const [nameAR, setNameAR] = useState(undefined);
  const [nameEN, setNameEN] = useState(undefined);
  const [country, setCountry] = useState("");
  const [descriptionAR, setDescriptionAR] = useState("");
  const [descriptionEN, setDescriptionEN] = useState("");
  const [websiteAR, setWebsiteAR] = useState("");
  const [websiteEN, setWebsiteEN] = useState("");

  const backPressed = () => {
    setShowPromCode(false);
  };

  const currentDate = new Date();
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  const formattedDate = currentDate.toLocaleString("en-US", options);

  // The Main object
  const sendNotification = {
    data: {
      offerid: `${formattedDate}S`,
      id: `${formattedDate}s`,
      country: country,
      translated_title: descriptionEN,
      title: descriptionAR,
      notificationTitleAr: nameAR,
      notificationTitleEn: nameEN,
      link_ar: websiteAR,
      link_en: websiteEN,
      tsawq: "me",
    },
  };

  const handleCountryChange = (value) => {
    setCountry(value);
  };

  // The Image container show
  const handleImageChange = (value) => {
    if (value === "Enable") {
      setImageTrue(true);
    } else {
      setImageTrue(false);
    }
  };

  // The Name  EN  Imput
  const nameValueAR = (event) => {
    setNameAR(event.target.value);
  };

  //handel link AR
  const handelWebsiteValueAR = (event) => {
    setWebsiteAR(event.target.value);
  };

  //handel link EN
  const handelWebsiteValueEN = (event) => {
    setWebsiteEN(event.target.value);
  };

  // The Name  AR  Imput
  const nameValueEN = (event) => {
    setNameEN(event.target.value);
  };

  // The Description Arabic Imput
  const handelTypeValueAR = (event) => {
    setDescriptionAR(event.target.value);
  };

  // The Description English Imput
  const handelTypeValueEN = (event) => {
    setDescriptionEN(event.target.value);
  };

  // The Submit Button Founction Start -->
  const buttonCliked = async () => {
    if (country === "" || descriptionAR === "" || descriptionEN === "") {
      MySwal.fire({
        title: (
          <div>
            <h3 style={{ color: "red" }}>فشل التسجيل</h3>
            <p>تأكد من كل الخانات الإجبارية</p>
          </div>
        ),
        didOpen: () => {
          MySwal.showLoading();
        },
      });
      setTimeout(() => {
        MySwal.close();
      }, 2000);
    } else {
      MySwal.fire({
        title: (
          <div>
            <h3 style={{ color: "blue" }}>جاري الإرسال</h3>
          </div>
        ),

        didOpen: () => {
          MySwal.showLoading();
        },
      });
      await sendNotificationRequest(
        sendNotification,
        image_En_Data,
        image_Ar_Data,
      );
    }
  };

  // <-- The Submit Button Founction End

  // Sending Notification Via API Function Start -->
  async function sendNotificationRequest(
    sendNotification,
    image_En_Data,
    image_Ar_Data,
  ) {
    const notificationResponde = await sendNotificationCall(
      sendNotification,
      image_En_Data,
      image_Ar_Data,
    );
    if (notificationResponde) {
      MySwal.close();
      form.resetFields();
      setCountryTrue(false);
      setImageTrue(false);
      setCountry("");
      setNameAR(undefined);
      setNameEN(undefined);
      setDescriptionAR("");
      setDescriptionEN("");
      setWebsiteAR("");
      setWebsiteEN("");
      setImage_En_data("");
      setImage_Ar_data("");
      sendNotification.data.offerid = "";
      sendNotification.data.id = "";
      return MySwal.fire(
        <div>
          <h3 style={{ color: "green" }}> {notificationResponde}</h3>
        </div>,
      );
    } else {
      return MySwal.fire(
        <div>
          <h3 style={{ color: "red" }}>فشل التسجيل</h3>
        </div>,
      );
    }
  }
  // <-- Sending Notification Via API Function End

  return (
    <div>
      <Header>
        {isCorrectCode && (
          <Button
            onClick={() => {
              MySwal.fire(
                <div>
                  <h1 style={{ color: "red" }}>تم تسجيل الخروج</h1>
                </div>,
              );
              localStorage.removeItem("isLoggedIn");
              setIsCorrectCode(false);
            }}
            variant="danger"
          >
            تسجيل خروج
          </Button>
          // backPressed
        )}
        {isCorrectCode && (
          <Button
            onClick={backPressed}
            style={{
              backgroundColor: "#000",
              borderColor: "#000",
              fontSize: 20,
              marginLeft: "1%",
            }}
          >
            القائمة الرائيسية
          </Button>
        )}
      </Header>
      <h1 style={{ margin: 20, color: "#f1fae3", fontWeight: "bold" }}>
        Send Notification
      </h1>

      {!isCorrectCode ? (
        <PhoneAuth isCorrectCode={setIsCorrectCode} />
      ) : (
        <StyledForm
          style={{
            direction: "rtl",
          }}
          form={form}
          layout="vertical"
        >
          <Col span={12}>
            <Form.Item
              label={
                <div>
                  <h3>البلد</h3>
                </div>
              }
              name="Country"
              rules={[{ required: true, message: "Please select Country!" }]}
            >
              <Select placeholder="اختر البلد" onChange={handleCountryChange}>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="all">
                  الكل
                </Option>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="eg">
                  مصر
                </Option>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="sa">
                  المملكة السعودية
                </Option>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="kw">
                  الكويت
                </Option>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="ae">
                  الأمارات
                </Option>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="qa">
                  قطر
                </Option>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="bh">
                  البحرين
                </Option>
                <Option style={{ fontSize: 17, direction: "rtl" }} value="om">
                  عمان
                </Option>
              </Select>
            </Form.Item>
          </Col>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <div>
                    <h3>الأسم بالعربي</h3>
                  </div>
                }
                name="promoName-ar"
                rules={[
                  {
                    required: true,
                    message: "من فضلك اخل اسم العرض بالعربي",
                  },
                ]}
              >
                <Input.TextArea
                  style={{ fontSize: 17 }}
                  placeholder="اسم العرض"
                  autoSize={{ minRows: 1, maxRows: 20 }}
                  onChange={nameValueAR}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <div>
                    <h3>الأسم بالانجليزي</h3>
                  </div>
                }
                name="promoName-en"
                rules={[
                  {
                    required: true,
                    message: "من فضلك اخل اسم العرض بالانجليزي",
                  },
                ]}
              >
                <Input.TextArea
                  style={{ fontSize: 17, direction: "ltr" }}
                  placeholder="اسم العرض"
                  autoSize={{ minRows: 1, maxRows: 20 }}
                  onChange={nameValueEN}
                />
              </Form.Item>
            </Col>

            {countryTrue && (
              <Col span={12}>
                <Form.Item
                  label={
                    <div>
                      <h3>المتجر</h3>
                    </div>
                  }
                  name="appliesTo"
                  rules={[{ required: true, message: "من فضلك اختر المتجر" }]}
                ></Form.Item>
              </Col>
            )}

            <Col span={12}>
              <Form.Item
                label={
                  <div>
                    <h3>الوصف بالعربي</h3>
                  </div>
                }
                name="descriptionAR"
                rules={[
                  {
                    required: true,
                    message: "الرجاء ادخال الوصف بالعربي",
                  },
                ]}
              >
                <Input.TextArea
                  placeholder="ادخال الوصف"
                  autoSize={{ minRows: 1, maxRows: 20 }}
                  value={descriptionAR}
                  onChange={handelTypeValueAR}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label={
                  <div>
                    <h3>الوصف بالانجليزي</h3>
                  </div>
                }
                name="descriptionEN"
                rules={[
                  {
                    required: true,
                    message: "الرجاء ادخال الوصف بالانجليزي",
                  },
                ]}
              >
                <Input.TextArea
                  style={{ direction: "ltr" }}
                  placeholder="ادخال الوصف"
                  autoSize={{ minRows: 1, maxRows: 20 }}
                  value={descriptionEN}
                  onChange={handelTypeValueEN}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <div>
                    <h3>إضافة لينك بالعربي</h3>
                  </div>
                }
                name="WebsiteAR"
              >
                <Input.TextArea
                  style={{ direction: "ltr" }}
                  placeholder="https://"
                  value={websiteAR}
                  autoSize={{ minRows: 1, maxRows: 10 }}
                  onChange={handelWebsiteValueAR}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label={
                  <div>
                    <h3>إضافة لينك بالانجليزي</h3>
                  </div>
                }
                name="WebsiteEN"
              >
                <Input.TextArea
                  style={{ direction: "ltr" }}
                  placeholder="https://"
                  value={websiteEN}
                  autoSize={{ minRows: 1, maxRows: 10 }}
                  onChange={handelWebsiteValueEN}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label={
                  <div>
                    <h3>إضافة صوره</h3>
                  </div>
                }
                name="Image"
              >
                <Select
                  placeholder="أختر حالة الصور"
                  onChange={handleImageChange}
                >
                  <Option
                    style={{ direction: "rtl", fontSize: 17 }}
                    value="Disable"
                  >
                    اغلاق
                  </Option>
                  <Option
                    style={{ direction: "rtl", fontSize: 17 }}
                    value="Enable"
                  >
                    تفعيل
                  </Option>
                </Select>
              </Form.Item>
            </Col>

            {imageTrue && (
              <ImgaeSection>
                <Row>
                  <Form.Item name="importantImage_en" label="الصورة انجليزي">
                    <ImageUploader
                      imageLang={"en"}
                      setImagedata={setImage_En_data}
                    />
                  </Form.Item>
                  <Form.Item name="importantImage_ar" label="الصورة عربي">
                    <ImageUploader
                      imageLang={"ar"}
                      setImagedata={setImage_Ar_data}
                    />
                  </Form.Item>
                </Row>
              </ImgaeSection>
            )}
          </Row>

          <Button
            style={{ margin: "5%", marginBottom: "2%" }}
            onClick={buttonCliked}
            variant="success"
          >
            إرسال
          </Button>
        </StyledForm>
      )}
    </div>
  );
};

export default SendNotification;
